<template>
  <el-select
    v-model="valueBackUp"
    :clearable="clearable"
    :placeholder="placeholder"
    :style="width ? `width: ${width}` : ''"
    @change="handleChange"
    :multiple="multiple"
    filterable
    :disabled="disabled"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.role_name"
      :value="item.id"
      :disabled="disabledIds.includes(item.id)"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/administratorRole';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    width: String,
    clearable: Boolean,
    multiple: Boolean,
    placeholder: {
      type: String,
      default: '请选择管理员职位',
    },
    disabled: Boolean,
    disabledIds: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    valueBackUp: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackUp)) this.valueBackUp = value || [];
      } else {
        if (value !== this.valueBackUp) this.valueBackUp = +value || '';
      }
    },
    valueBackUp(valueBackUp) {
      if (this.multiple) {
        if (JSON.stringify(valueBackUp) !== JSON.stringify(this.value)) this.$emit('input', valueBackUp);
      } else {
        if (valueBackUp !== (+this.value || '')) this.$emit('input', valueBackUp);
      }
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({ is_all: 1 });
      if (isError) return;

      this.list = data;
    },
    handleChange(valueBackUp) {
      this.$emit('change', valueBackUp);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackUp = this.value || [];
    } else {
      this.valueBackUp = +this.value || '';
    }
    this.getList();
  },
};
</script>
